import React from 'react';

/**
 * Full-screen welcome / device-selection screen.
 * Shown once at the start of a session, before the checklist appears.
 * Calling onSelect('win' | 'mac') sets the OS and enters the checklist.
 */
export default function WelcomeScreen({ onSelect }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'Segoe UI', -apple-system, sans-serif",
        backgroundImage: 'url(/welcome-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}
    >
      {/* Readability scrim over the photo */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(28,31,36,0.55) 0%, rgba(28,31,36,0.78) 100%)',
        }}
      />

      {/* Content */}
      <div
        style={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 20px',
          textAlign: 'center',
        }}
      >
        <img
          src="/protegrity-logo.png"
          alt="Protegrity"
          style={{ height: 48, width: 'auto', marginBottom: 28 }}
        />

        <h1
          style={{
            color: '#fff',
            fontSize: 30,
            fontWeight: 700,
            margin: '0 0 10px',
            letterSpacing: 0.2,
          }}
        >
          Welcome to Protegrity
        </h1>

        <p
          style={{
            color: 'rgba(255,255,255,0.88)',
            fontSize: 17,
            lineHeight: 1.6,
            margin: '0 0 34px',
            maxWidth: 560,
          }}
        >
          We're glad to have you with us. This guided session will walk you
          through everything you need to get your account, device and tools
          ready.
        </p>

        <div
          style={{
            color: '#fff',
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 16,
            letterSpacing: 0.3,
          }}
        >
          To begin, please select the device you have been issued
        </div>

        <div
          style={{
            display: 'flex',
            gap: 16,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <DeviceCard
            icon="🖥️"
            title="Windows laptop"
            subtitle="Dell, Lenovo or similar"
            onClick={() => onSelect('win')}
          />
          <DeviceCard
            icon="💻"
            title="MacBook"
            subtitle="Apple macOS device"
            onClick={() => onSelect('mac')}
          />
        </div>

      </div>

    </div>
  );
}

function DeviceCard({ icon, title, subtitle, onClick }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: 230,
        padding: '22px 18px',
        borderRadius: 10,
        cursor: 'pointer',
        fontFamily: 'inherit',
        textAlign: 'center',
        transition: 'all 0.18s ease',
        background: hover ? '#009245' : 'rgba(255,255,255,0.95)',
        color: hover ? '#fff' : '#1C1F24',
        border: hover ? '2px solid #82D222' : '2px solid rgba(255,255,255,0.9)',
        transform: hover ? 'translateY(-2px)' : 'none',
      }}
    >
      <div style={{ fontSize: 34, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 3 }}>
        {title}
      </div>
      <div
        style={{
          fontSize: 13.5,
          color: hover ? 'rgba(255,255,255,0.85)' : '#5F5E5A',
        }}
      >
        {subtitle}
      </div>
    </button>
  );
}
